/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {isNil} from 'lodash'
import {
  HomepageMock,
  withdrawRecordsMock,
  rewardRecordsMock,
  HelpRecordsMock,
  LotteryMock,
  TaskListMock,
  extractCoinsMock,
  shareCallbackMock,
  shareInfoMock,
} from './mock'

export const getHomepage = createAsyncThunk(
  'SpinNewUser/getHomepage',
  async (_, store: any) => {
    // todo
    // return HomepageMock
    const resp = await http.post(
      '/live/activity/wheel_pull_new_homepage',
      {},
      {
        store: window.store,
      }
    )
    return resp.data.data
  }
)

export async function getWithdrawRecords() {
  // return withdrawRecordsMock
  const resp = await http.post(
    '/live/activity/wheel_pull_new_withdraw_records',
    {},
    {
      store: window.store,
    }
  )
  return resp.data.data
}

// /live/activity/wheel_pull_new_reward_records
export async function getRewardRecords() {
  // return rewardRecordsMock
  const resp = await http.post(
    '/live/activity/wheel_pull_new_reward_records',
    {},
    {
      store: window.store,
    }
  )
  return resp.data.data
}

// /live/activity/wheel_pull_new_invite_valid_records
export async function getHelpRecords() {
  // return HelpRecordsMock
  const resp = await http.post(
    '/live/activity/wheel_pull_new_invite_valid_records',
    {},
    {
      store: window.store,
    }
  )
  return resp.data.data
}

// /live/activity/wheel_pull_new_lottery
export async function Lottery() {
  // return LotteryMock
  const resp = await http.post(
    '/live/activity/wheel_pull_new_lottery',
    {},
    {
      store: window.store,
    }
  )
  return resp.data.data
}

// /live/activity/wheel_pull_new_task_list
export async function getTaskList() {
  // return TaskListMock
  const resp = await http.post(
    '/live/activity/wheel_pull_new_task_list',
    {},
    {
      store: window.store,
    }
  )
  return resp.data.data
}

// live/activity/wheel_pull_new_extract_coins
export async function extractCoins(params) {
  // return extractCoinsMock
  const resp = await http.post(
    '/live/activity/wheel_pull_new_extract_coins',
    {...params},
    {
      store: window.store,
    }
  )
  return resp.data.data
}

// /live/activity/wheel_pull_new_share_callback
export async function shareCallback(params) {
  // return shareCallbackMock
  const resp = await http.post(
    '/live/activity/wheel_pull_new_share_callback',
    {...params},
    {
      store: window.store,
    }
  )
  return resp.data.data
}

// /live/activity/wheel_pull_new_share_info
export async function getShareInfo(params) {
  // return shareInfoMock
  const resp = await http.post(
    '/live/activity/wheel_pull_new_share_info',
    {...params},
    {}
  )
  return resp.data.data
}

export async function wheel_pull_new_invite_list(params) {
  const resp = await http.post(
    '/live/activity/wheel_pull_new_invite_list',
    {...params},
    {
      store: window.store,
    }
  )
  return resp.data.data
}

const initialState = {
  homepage: null,
  curModalIndex: null,
}

export const SpinNewUserSlice = createSlice({
  name: 'SpinNewUser',
  initialState,
  reducers: {
    setCurModalIndex: (state, action) => {
      state.curModalIndex = action.payload
    },
    updateCurModalIndex: (state) => {
      state.curModalIndex += 1
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getHomepage.fulfilled, (state, action) => {
      Object.assign(state, {homepage: action.payload})
    })
    // builder.addCase(getRuleInfo.fulfilled, (state, action) => {
    //   const {data} = action.payload
    //   state.rule = data
    // })
    // builder.addCase(getRank.fulfilled, (state, action) => {
    //   const {data} = action.payload
    //   state.rank = data
    // })
    // builder.addCase(getStageTaskInfo.fulfilled, (state, action) => {
    //   const {data} = action.payload
    //   const rewardList = []
    //   data?.stages?.forEach((item) => {
    //     rewardList.push(...item?.reward_infos)
    //   })
    //   state.stageTask = {
    //     ...data,
    //     rewardList,
    //   }
    // })
  },
})

export default SpinNewUserSlice.reducer
export const SpinNewUserActions = SpinNewUserSlice.actions
